<template>
  <div class="w-full h-full flex items-center justify-center py-16 px-8 relative overflow-hidden">
    <!-- 배경 그라데이션 효과 -->
    <div class="absolute inset-0 bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900"></div>
    <div class="absolute inset-0 bg-gradient-to-t from-emerald-900/10 via-transparent to-transparent"></div>
    
    <div class="max-w-7xl w-full text-center relative z-10">
      <!-- Main Title -->
      <div class="mb-10">
        <h1 class="text-6xl font-bold mb-4 bg-gradient-to-r from-blue-400 via-emerald-300 to-orange-400 bg-clip-text text-transparent">
          사모펀드 분석 에이전트
        </h1>
        <!-- <div class="flex items-center justify-center gap-2 mb-4">
          <span class="text-emerald-400 font-bold text-sm px-3 py-1 border-2 border-emerald-400 rounded-md animate-pulse">ON</span>
        </div> -->
      </div>

      <!-- Subtitle -->
      <div class="mb-20">
        <p class="text-3xl text-gray-300 font-medium mb-2">AI 기반 투자 분석 시스템</p>
        <p class="text-base text-gray-400">스마트한 AI 기술로 투자 의사결정을 지원합니다</p>
      </div>

      <!-- Features Grid -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Feature 1: Asset Management -->
        <div class="group card hover:border-blue-500/50 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-blue-500/20 p-8">
          <div class="mb-6 flex justify-center">
            <div class="h-16 w-16 rounded-full bg-gradient-to-br from-blue-500/20 to-blue-600/20 flex items-center justify-center border border-blue-500/30 group-hover:border-blue-400/50 transition-colors">
              <i class="bi bi-graph-up-arrow text-3xl text-blue-400"></i>
            </div>
          </div>
          <h3 class="text-xl font-bold text-white mb-3 group-hover:text-blue-300 transition-colors">자산운용사 분석</h3>
          <p class="text-base text-gray-300 leading-relaxed">
            자산운용사의 리포트를 분석하여<br>
            종합 평가를 제공합니다
          </p>
        </div>

        <!-- Feature 2: Verification -->
        <div class="group card hover:border-emerald-500/50 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-emerald-500/20 p-8">
          <div class="mb-6 flex justify-center">
            <div class="h-16 w-16 rounded-full bg-gradient-to-br from-emerald-500/20 to-emerald-600/20 flex items-center justify-center border border-emerald-500/30 group-hover:border-emerald-400/50 transition-colors">
              <i class="bi bi-clipboard-check text-3xl text-emerald-400"></i>
            </div>
          </div>
          <h3 class="text-xl font-bold text-white mb-3 group-hover:text-emerald-300 transition-colors">투자상품설명서 검증</h3>
          <p class="text-base text-gray-300 leading-relaxed">
            투자상품설명서의 내용을 확인하여<br>
            사실 여부를 검증합니다
          </p>
        </div>

        <!-- Feature 3: Risk Analysis -->
        <div class="group card hover:border-orange-500/50 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-orange-500/20 p-8">
          <div class="mb-6 flex justify-center">
            <div class="h-16 w-16 rounded-full bg-gradient-to-br from-orange-500/20 to-orange-600/20 flex items-center justify-center border border-orange-500/30 group-hover:border-orange-400/50 transition-colors">
              <i class="bi bi-shield-exclamation text-3xl text-orange-400"></i>
            </div>
          </div>
          <h3 class="text-xl font-bold text-white mb-3 group-hover:text-orange-300 transition-colors">리스크 분석</h3>
          <p class="text-base text-gray-300 leading-relaxed">
            투자대상기업의 리스크를 분석하고<br>
            위험도를 평가합니다
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
</style>
